import React, { useState, useEffect } from 'react';
import Select from 'react-select'
import config from '../../config/index';
import axios from 'axios'

const returnOptions = [
  { value: 'Product not what I thought', label: 'Product not what I thought' },
  { value: 'Change of mind', label: 'Change of mind' },
  { value: 'Other', label: 'Other' }
]

const customStyles = {
  control: ( provided ) => ({
    ...provided,
    borderRadius: 0,
  }),
  menuPortal: base => ({ ...base, zIndex: 9999999 }),
  theme: ( theme ) => ({
    ...theme,
    colors: {
      ...theme.colors,
      primary: 'black',
      primary75: 'black',
      primary25: '#F0F0F0'
    }
  })
};

const sizesOrder = [
  'xxxs',
  'xxs',
  'xs',
  's',
  'm',
  'l',
  'xl',
  'xxl',
  '2xl',
  '3xl',
  '4xl',
  '5xl'
]

const LineItem = ({ item, onChange }) => {
  const [selectedOption, setSelectedOption ] = useState( null );
  const [productImage, setProductImage] = useState(null)

  const sizeOptions = (item.variant && item.variant.product ? item.variant.product.variants.filter( v => v.option1 && v.inventory_quantity > 0 ).filter( v => v.option1 !== item.variant.option1 ).map( v => ({
    value: v.option1,
    label: v.option1,
  })) : []).sort((a, b) => {
    if (sizesOrder.indexOf(a.label.toLowerCase()) < sizesOrder.indexOf(b.label.toLowerCase())) {
      return -1
    }

    return 1
  })

  let quantityOptions = []
  if(item.quantity > 1) {
    for (let i = 0; i < item.quantity; i++) {
      quantityOptions.push({ label: `${i + 1}`, value: i + 1})
    }
  }


  const handleChange = (data) => {
    onChange({ ...data, item });
  }

  useEffect(() => {
    axios.get(`${config.backendUrl}/shopify-store/${config.storeId}/products/${item.product_id}/${item.variant_id}/image`)
    .then( response => {
      setProductImage(response.data)
    })
    .catch(e => {
      console.error(e)
    })

  }, [])

  return (
    <div className="line-item">
       <div
          style={{
            backgroundImage: `url(${productImage})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            height: 230,
            minWidth: 184
          }}
        >
        </div>
      <div>
        <h2>{item.title}</h2>
        <h3>{item.variant ? `Size ${item.variant.option1}` : item.variant_title}</h3>
        {
        (!item.hasBeenReturned && item.canReturn && item.variant) && (
          <div>
            <div className={`item-actions ${selectedOption && 'open'}`}>
              <div className={`tb-btn ${selectedOption !== 'returns' && 'outline'}`} onClick={() => setSelectedOption( 'returns' )}>Return</div>
              <div style={{ padding: 20 }}>OR</div>
              <div className={`tb-btn ${selectedOption !== 'exchanged' && 'outline'}`} onClick={() => setSelectedOption( 'exchanged' )}>Exchange</div>
            </div>
            {selectedOption === 'returns' && (
              <div>
                {item.quantity > 1 && (
                  <div style={{ marginBottom: 10 }}>
                    <Select 
                      menuPortalTarget={document.body} 
                      onChange={(value) => {
                        handleChange( { quantity: value.value } )
                      }} 
                      options={quantityOptions} 
                      styles={customStyles} 
                      theme={customStyles.theme} placeholder="Quantity" 
                    />
                  </div>  
                  )}
                  <Select menuPortalTarget={document.body} onChange={(value) => {
                      handleChange({ reason: value.value, type: 'returns'})
                    }}  options={returnOptions} styles={customStyles} theme={customStyles.theme} placeholder="Reason" />
              </div>
            )}
            {selectedOption === 'exchanged' && (
              <div>
                {item.quantity > 1 && (
                  <div style={{ marginBottom: 10 }}>
                    <Select 
                      menuPortalTarget={document.body} 
                      onChange={(value) => {
                        handleChange( { quantity: value.value } )
                      }} 
                      options={quantityOptions} 
                      styles={customStyles} 
                      theme={customStyles.theme} placeholder="Quantity" 
                    />
                    </div>
                )}
                <Select 
                  menuPortalTarget={document.body} 
                  onChange={(value) => { 
                    handleChange({ exchangeSize: value.value, type: 'exchanged'})
                  }}  
                  options={sizeOptions} 
                  styles={customStyles} 
                  theme={customStyles.theme} 
                  placeholder="Select New Size" 
                />
              </div>  
            )} 
          </div>
        )} 
        {
          item.alreadyReturned && (
            <div>
            <small>This item has already been {item.returnReason === 'exchanged' ? 'exchanged' : 'returned'}.</small>
          </div>
          )
        }
        {
          !item.alreadyReturned && !item.canReturn && (
            <div style={{ marginTop: 10 }}>
            <small>{`This item is ineligible for a return`}</small>
          </div>
          )
        }
      </div>
    </div>
  )
}

export default LineItem;